import {
  BuildingInsights_120,
  Carbon20,
  DataBase20,
  Globe20,
  Plug20,
  Types24,
  VmdkDisk24,
} from '@carbon/icons-react';
import countries from './countryData';
import messages from '../locales/messages';
import { FormattedMessage } from 'react-intl';

export default {
  // Left this just as an example
  usableStorage: {
    label: <FormattedMessage {...messages.usableStorageLabel} />,
    tooltip: <FormattedMessage {...messages.usableStorageTooltip} />,
    amountValue: [50, 100, 250, 500, 1000],
  },
  performanceLevel: {
    label: <FormattedMessage {...messages.performanceLevelLabel} />,
    tooltip: <FormattedMessage {...messages.performanceLevelTooltip} />,
    performanceValue: [
      {
        label: <FormattedMessage {...messages.liteLabel} />,
        range: 'lite',
        performanceRange: '20k-100k IOPS',
      },
      {
        label: <FormattedMessage {...messages.mediumLabel} />,
        range: 'medium',
        performanceRange: '100k-200k IOPS',
      },
      {
        label: <FormattedMessage {...messages.highLabel} />,
        range: 'high',
        performanceRange: '200k-420k IOPS',
      },
      {
        label: <FormattedMessage {...messages.extremeLabel} />,
        range: 'extreme',
        performanceRange: '420k-1.25M IOPS',
      },
    ],
  },
  comparisonTable: {
    AverageTitle: <FormattedMessage {...messages.averageTitleLabel} />,
    averageTooltip: <FormattedMessage {...messages.averageTitleTooltip} />,
    carbonOutputMetric: <FormattedMessage {...messages.carbonOutputMetric} />,
    comparisonVariables: [
      {
        icon: <VmdkDisk24 />,
        label: <FormattedMessage {...messages.driveNumberLabel} />,
        toolTip: <FormattedMessage {...messages.driveNumberTooltip} />,
      },
      {
        icon: <Types24 />,
        label: <FormattedMessage {...messages.driveTypeLabel} />,
        toolTip: <FormattedMessage {...messages.driveTypeTooltip} />,
      },
      {
        icon: <DataBase20 />,
        label: <FormattedMessage {...messages.rackUnityLabel} />,
        toolTip: <FormattedMessage {...messages.rackUnityTooltip} />,
      },
      {
        icon: <Carbon20 />,
        label: <FormattedMessage {...messages.carbonOutputLabel} />,
        toolTip: <FormattedMessage {...messages.carbonOutputTooltip} />,
      },
    ],
    electricityCarbonLabel: (
      <FormattedMessage {...messages.electricityCarbonLabel} />
    ),
    savedTreeLabel: <FormattedMessage {...messages.savedTreeLabel} />,
    savedTreeLabelComplement: (
      <FormattedMessage {...messages.savedTreeLabelComplement} />
    ),
  },
  assumptionsTable: {
    assumptionsTitle: <FormattedMessage {...messages.assumptionsTitle} />,
    carbonIntensityMetric: (
      <FormattedMessage {...messages.carbonIntensityMetric} />
    ),
    countryData: countries,
    evaluatedVariables: [
      {
        icon: <Globe20 />,
        label: <FormattedMessage {...messages.countrySelectionLabel} />,
        tooltip: <FormattedMessage {...messages.countrySelectionTooltip} />,
      },
      {
        icon: <Plug20 />,
        label: <FormattedMessage {...messages.priceKWhLabel} />,
        tooltip: <FormattedMessage {...messages.priceKWhTooltip} />,
      },
      {
        icon: <Carbon20 />,
        label: <FormattedMessage {...messages.carbonIntensityLabel} />,
        tooltip: <FormattedMessage {...messages.carbonIntensityTooltip} />,
      },
      {
        icon: <BuildingInsights_120 />,
        label: <FormattedMessage {...messages.PueFactorLabel} />,
        tooltip: <FormattedMessage {...messages.PueFactorTooltip} />,
      },
    ],
    footnote: <FormattedMessage {...messages.footnote} />,
  },
};
